import { isArray } from '../type-checkers/type-checkers';

const INSTANCE = Symbol('singleton-decorator:instance');

function getInstance (target: any, args: any = []) {
    if (!isArray(args)) {
        args = [args];
    }
    return target[INSTANCE] = target[INSTANCE] instanceof target ? target[INSTANCE] : new target(...args);
}

export function Singleton (target: any): any {
  const singletonInstance = getInstance.bind(null, target);
  return singletonInstance;
}
